import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import skillContent from '../assests/img/skill-content.jpg';
import { Helmet } from 'react-helmet-async';


function Skilleducation() {
  return (
    <div >
      <Helmet>
        <title>Skill Education | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about the State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}
      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy." />
          <h1 className='page-title'>Skill Education</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container skill-education-container'>
          <div className="content-secion">
            <img src={skillContent} alt="State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy." />
          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Skilleducation;
